import React, {
  useCallback, useContext, useEffect
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption,
  ButtonBar,
  ErrorMessage,
  ScreenHeader,
  getRadioGroupValue
} from '../../components';

import { NewWillContext } from './new-will-provider';

export function NewWillAssetDistributionScreen() {
  const navigate = useNavigate();

  const { will } = useContext(NewWillContext);

  const [ error, setError ] = React.useState('');

  const radioGroupName = 'asset-distribution';

  useEffect(() => {
    console.log('newWill', will);
    if (will?.primaryBeneficiaryId) {
      (document.getElementById('asset-distribution-single') as HTMLInputElement).checked = true;
    }
  }, [ will ]);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    const value = getRadioGroupValue(radioGroupName);

    if (!value) {
      setError('Please select an option');
      return;
    }

    if (value === 'single') {
      // Navigate to the next screen for single distribution
      navigate('../single-beneficiary');
      return;
    }

    navigate('../asset-summary');
  }, [ navigate ]);

  // TODO: if user comes back to this screen they will lose all their assets
  // all asset selection screens need to be wrapped in provider that stores the state
  return (
    <div className="new-will-asset-distribution-screen screen">
      <ScreenHeader 
        title="Asset Distribution"
        description="Choose how you'd like to distribute your assets"
        handleBack={handleBack} 
        steps={6} 
        step={2} 
      />

      <div className="asset-distribution-option-container">
        <AssetDistributionOption 
          id="asset-distribution-single" 
          label="Leave all assets to a single individual" 
          description="All your assets will be distributed to one person."
          value="single"
        />
        <AssetDistributionOption 
          id="asset-distribution-single" 
          label="Leave all assets to a single individual except for some" 
          description="All your assets will be distributed to one person with exceptions."
          value="combined"
        />
        <AssetDistributionOption 
          id="asset-distribution-specific" 
          label="Specify individual distributions for each asset" 
          description="You can choose who gets each of your assets individually."
          value="specific"
        />
      </div>

      {/* TODO: re arrange these */}
      <ErrorMessage message={error} />
      <ButtonBar handlePrimary={handleNext} primaryText="Continue" />
    </div>
  );
}
